import { UnauthenticatedLayout } from './components/Layout/UnauthenticatedLayout';
import { ResetPassword } from './pages/ResetPassword';
import { routes } from './routes';
import { lazy } from 'react';
import { Redirect, Route, Switch, Router as Wouter } from 'wouter';

const Signin = lazy(async () => ({
  default: (await import('./pages/Signin')).Signin,
}));

const Signup = lazy(async () => ({
  default: (await import('./pages/Signup')).Signup,
}));

const ForgetPassword = lazy(async () => ({
  default: (await import('./pages/ForgetPassword')).ForgetPassword,
}));

export const UnauthenticatedRouter = () => {
  return (
    <UnauthenticatedLayout>
      <Wouter>
        <Switch>
          <Route path={routes.signUp}>
            <Signup />
          </Route>
          <Route path={routes.forgetPassword}>
            <ForgetPassword />
          </Route>
          <Route path={routes.signIn}>
            <Signin />
          </Route>
          <Route path={routes.resetPassword}>
            <ResetPassword />
          </Route>
          <Route>
            <Redirect to={routes.signIn} />
          </Route>
        </Switch>
      </Wouter>
    </UnauthenticatedLayout>
  );
};
